import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MailButton } from "@/components/contacting/Buttons";
import { PhoneCTA } from "@/components/contacting/Buttons/PhoneButton";
import { useIsStickyContactForm } from "@/components/contacting/hooks/useIsStickyContactForm";
import { BannerInfo } from "@/components/utilsComponents/openFormStickyBanner/BannerInfo";
import { ProjectBannerInfo } from "@/components/utilsComponents/openFormStickyBanner/ProjectBannerInfo";
import { useClassifiedId } from "@/contexts/classified";
import { useContactCardSection } from "@/contexts/contact";
import { useFarbwelt, useFavoriteTracking } from "@/hooks";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { Box } from "@gemini/core";
import { FavoriteHeart } from "@seeker-consumer-portal/favorite-heart";
import { useEffect, useRef, useState } from "react";
import { useIsPreviewMode } from "@/shared/hooks/useIsPreviewMode";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
export const openFormStickyBannerTestid = "cdp-open-form-sticky-banner";
export const OpenFormStickyBanner = () => {
    var _a;
    const stickyRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const { bgColor, showFarbweltBanner } = useFarbwelt();
    const { phoneNumbers = [] } = (_a = useContactCardSection()) !== null && _a !== void 0 ? _a : {};
    const { t } = useI18n();
    const isStickyContactForm = useIsStickyContactForm();
    const classifiedId = useClassifiedId();
    const favoriteTracking = useFavoriteTracking();
    const isProject = useIsNewBuildProject();
    const isPreviewMode = useIsPreviewMode();
    const { bWindow } = useBrowserAPI();
    useEffect(() => {
        const handleScroll = () => {
            if (stickyRef.current) {
                const offset = 1000;
                const stickyPosition = 
                // @ts-ignore
                stickyRef.current.getBoundingClientRect().top + offset;
                const scrollPosition = bWindow.scrollY;
                if (!isStickyContactForm && scrollPosition >= stickyPosition) {
                    setIsVisible(true);
                }
                else {
                    setIsVisible(false);
                }
            }
        };
        bWindow.addEventListener("scroll", handleScroll);
        return () => {
            bWindow.removeEventListener("scroll", handleScroll);
        };
    }, [isStickyContactForm, bWindow]);
    return (_jsxs(Box, { ref: stickyRef, testId: `${openFormStickyBannerTestid}-logo`, display: {
            "breakpoint.base": "none",
            "breakpoint.lg": "flex",
        }, position: "sticky", top: "0", flexDirection: "column", transitionDuration: "motionDuration.300", transitionTimingFunction: "motionEasing.linear", alignItems: "center", borderBottomColor: "color.border.light.default", borderBottomWidth: "borderWidth.1", borderBottomStyle: "solid", visibility: isVisible ? "visible" : "hidden", opacity: isVisible ? "opacity.full" : "opacity.none", height: isVisible ? "sizing.84" : "0px", backgroundColor: "color.surface.default.default", zIndex: "zIndex.2", children: [_jsxs(Box, { as: "span", width: "100%", paddingVertical: "spacing.12", typography: "typography.body.16.bold", color: "color.content.default.default", display: "flex", flexDirection: {
                    "breakpoint.base": "column",
                    "breakpoint.lg": "row",
                }, justifyContent: "space-between", alignItems: "center", children: [isProject ? _jsx(ProjectBannerInfo, {}) : _jsx(BannerInfo, {}), _jsxs(Box, { display: "flex", gap: "spacing.8", marginLeft: "auto", marginRight: {
                            "breakpoint.lg": "spacing.32",
                            "breakpoint.xl": "spacing.80",
                        }, children: [_jsx(PhoneCTA, { rootTestId: openFormStickyBannerTestid, phoneNumbers: phoneNumbers, showModal: true, legacyTrackingInfos: "static", trackingAvZone: "sticky_desktop", children: t("contact.card.show_phone") }), _jsx(MailButton, { av_zone: "sticky_desktop", legacyTrackingInfos: "sticky_desktop", rootTestId: openFormStickyBannerTestid }), !isPreviewMode && (_jsx(Box, { alignItems: "center", marginLeft: "spacing.8", display: {
                                    "breakpoint.lg": "none",
                                    "breakpoint.xl": "flex",
                                }, children: _jsx(FavoriteHeart, { classifiedId: classifiedId, tracking: favoriteTracking, border: true, black: false }) }))] })] }), showFarbweltBanner && (_jsx(Box, { width: "100%", display: "block", height: "sizing.16", unsafe_style: {
                    backgroundColor: bgColor,
                } }))] }));
};
